import type { LocalizedText } from "./i18n";

type DurationUnit = "day" | "hour";

function unitKey(unit: DurationUnit, count: number): LocalizedText {
  return count === 1 ? unit : `${unit}s`;
}

export function formatDurationLabel(args: { count: number; unit: DurationUnit; text: (value: LocalizedText) => string }): string {
  const { count, unit, text } = args;
  return `${count} ${text(unitKey(unit, count))}`;
}

export function formatLastDurationLabel(args: { count: number; unit: DurationUnit; text: (value: LocalizedText) => string }): string {
  const { count, unit, text } = args;
  return `${text("Last duration prefix")} ${formatDurationLabel({ count, unit, text })}`;
}
